import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import TextField from '@material-ui/core/TextField'
import React from 'react'
import KasKrsStyle from '../styles/KasKrsStyle'
import Button from '@material-ui/core/Button'

const KasKrs = ({ data, onSetSectionData, hasError, onLoadGUS }) => (
  <KasKrsStyle>
    <FormControl component="fieldset" className="radio">
      <FormLabel className="caption">Adresat sprawozdania</FormLabel>
      <RadioGroup
        className="radioGroup"
        row
        name="CzyKRS"
        aria-label="Adresat sprawozdania"
        value={data.CzyKRS ? 'true' : ''}
        onChange={onSetSectionData}
      >
        <FormControlLabel
          value=""
          control={<Radio color="primary" />}
          label="Szef KAS"
        />
        <FormControlLabel
          value="true"
          control={<Radio color="primary" />}
          label="KRS"
        />
      </RadioGroup>
    </FormControl>
    <FormControl component="fieldset" className="text">
      <TextField
        error={hasError('IdentyfikatorPodmiotu')}
        name="IdentyfikatorPodmiotu"
        label={data.CzyKRS ? 'Numer KRS' : 'NIP'}
        title={data.IdentyfikatorPodmiotu}
        defaultValue={data.IdentyfikatorPodmiotu}
        margin="normal"
        helperText="10 cyfr, bez myślników i spacji"
        onBlur={onSetSectionData}
      />
    </FormControl>
    <FormControl component="fieldset">
      <Button
        data-cy="getGus"
        className="buttonGUS"
        variant="contained"
        color="primary"
        onClick={() => {
          if (data.IdentyfikatorPodmiotu)
            onLoadGUS(data.CzyKRS, data.IdentyfikatorPodmiotu)
        }}
      >
        POBIERZ DANE Z GUS
      </Button>
    </FormControl>
  </KasKrsStyle>
)

export default KasKrs
